import { SELECT_BOAT, BOOKING_CARD } from '../actions/types';

export const selectBoatReducer = (state = null, action) => {
  switch (action.type) {
    case SELECT_BOAT:
      return action.payload !== undefined ? action.payload : state;
    default:
      return state;
  }
};

export const bookingCardReducer = (state = {}, action) => {
  switch (action.type) {
    case BOOKING_CARD:
      return action.payload;
    default:
      return state;
  }
};